import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import NavBar from './NavBar';
import Container from './Container';
import Footer from './Footer';
import MainMenu from './MainMenu';
import StaticPage from './noLoggued/StaticPage';
import LoginJS from './LoginJS';
import Modal from '../components/ModalSlide';

const scripts = [
    "/assets/vendor/libs/jquery/jquery.js",
    "/assets/vendor/libs/apex-charts/apexcharts.js",
    "/assets/js/config.js",
    "/assets/vendor/libs/popper/popper.js",
    "/assets/vendor/js/bootstrap.js",
    "./assets/vendor/js/helpers.js",
    "/assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.js",
    "/assets/vendor/js/menu.js",
    "/assets/js/loadmenu.js",
    "/assets/js/main.js",
    "/assets/js/dashboards-analytics.js",
    "https://buttons.github.io/buttons.js",
];



function MainLayout(props) {

    const logguedUserData = useSelector(state => state.common.logguedUserData);

    const dispatch = useDispatch();

    window.dispatch = dispatch;

    useEffect(() => {

        scripts.forEach(element => {
            if (!isScriptAlreadyIncluded(element)) {
                const script = document.createElement('script');
                script.src = element;
                script.async = true;
                document.body.appendChild(script);
            }
        });
    }, []);

    useEffect(() => {
        if (logguedUserData?.menu) {
            const timer = setInterval(() => {
                if (window.initializeMenu) {
                    window.initializeMenu();
                    clearTimer();
                }
            }, 500);
            const clearTimer = () => {
                clearInterval(timer);
            }
        }
    }, [logguedUserData?.menu]);

    const isScriptAlreadyIncluded = (src) => {
        var scripts = document.getElementsByTagName("script");
        for (var i = 0; i < scripts.length; i++) {
            if (scripts[i].getAttribute('src') == src) {
                return true;
            }
        }
        return false;
    }



    return (
        <>
            {
                !logguedUserData && <StaticPage />
            }
            {
                logguedUserData &&
                <div className="layout-wrapper layout-content-navbar">
                    <div className="layout-container">
                        <MainMenu />
                        <div className="layout-page">
                            <NavBar />
                            <div className="content-wrapper">
                                <Container />
                                <Footer />
                                <div className="content-backdrop fade"></div>

                            </div>
                        </div>
                    </div>
                    <div className="layout-overlay layout-menu-toggle"></div>
                </div>
            }
            <ToastContainer />
            <LoginJS />
            <Modal />

        </>
    );
}

export default MainLayout;